import React, { Component } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link, withRouter } from 'react-router-dom';
import { Trans } from 'react-i18next';
import axios from 'axios';
import { getAdminBreadcrumb, getAdminPageTitle } from './routeTitles';

const baseUrl = process.env.NODE_ENV === 'development'
  ? process.env.REACT_APP_BACKEND_LOCAL_API
  : process.env.REACT_APP_BACKEND_LIVE_API;

class Navbar extends Component {
  logout = () => {
    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };
    axios.post(baseUrl + 'logout', {}, { headers })
      .then(() => {
        localStorage.removeItem('token');
        try { localStorage.removeItem('staff_user_type'); } catch (_) {}
        window.location.assign('/adminlogin');
      })
      .catch((e) => {
        if (e.response?.status === 401) {
          localStorage.removeItem('token');
          try { localStorage.removeItem('staff_user_type'); } catch (_) {}
          window.location.assign('/adminlogin');
        }
      });
  };

  render() {
    const { userAname, usertype, themeMode, onToggleTheme, onToggleNav, location } = this.props;
    const isLight = (themeMode || 'light') === 'light';
    const pathname = location?.pathname || '/dashboard';
    const pageTitle = getAdminPageTitle(pathname);
    const crumbs = getAdminBreadcrumb(pathname);

    return (
      <header className="admin-header-v3 admin-layout-navbar">
        <button
          type="button"
          className="admin-header-v3__menu"
          onClick={() => (typeof onToggleNav === 'function' ? onToggleNav() : null)}
          aria-label="Open menu"
        >
          <span className="mdi mdi-menu" />
        </button>

        <div className="admin-header-v3__titles">
          <div className="admin-header-v3__breadcrumb">{crumbs.join(' · ')}</div>
          <h1 className="admin-header-v3__title">{pageTitle}</h1>
        </div>

        <div className="admin-header-v3__actions">
          <button
            type="button"
            className="admin-header-v3__icon-btn admin-theme-toggle"
            onClick={() => (typeof onToggleTheme === 'function' ? onToggleTheme() : null)}
            aria-label={isLight ? 'Switch to dark theme' : 'Switch to light theme'}
            title={isLight ? 'Dark mode' : 'Light mode'}
          >
            <span className={`mdi ${isLight ? 'mdi-weather-night' : 'mdi-white-balance-sunny'}`} />
          </button>

          <Dropdown alignRight as="div">
            <Dropdown.Toggle as="button" type="button" className="admin-header-v3__user border-0">
              <img src="https://cdn-icons-png.flaticon.com/512/2206/2206368.png" alt="" />
              <div className="d-none d-sm-block text-left">
                <div className="admin-header-v3__user-name">{userAname || 'Admin'}</div>
                <div className="admin-header-v3__user-role">{usertype || 'Admin'}</div>
              </div>
              <span className="mdi mdi-chevron-down d-none d-sm-inline" style={{ color: '#94a3b8' }} />
            </Dropdown.Toggle>
            <Dropdown.Menu className="navbar-dropdown preview-list navbar-profile-dropdown-menu" alignRight>
              <Dropdown.Item as={Link} to="/dashboard" className="preview-item">
                <div className="preview-thumbnail">
                  <div className="preview-icon bg-dark rounded-circle">
                    <i className="mdi mdi-view-dashboard text-primary" />
                  </div>
                </div>
                <div className="preview-item-content">
                  <p className="preview-subject mb-1"><Trans>Dashboard</Trans></p>
                </div>
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item as={Link} to="/admin/profile" className="preview-item">
                <div className="preview-thumbnail">
                  <div className="preview-icon bg-dark rounded-circle">
                    <i className="mdi mdi-account-circle text-primary" />
                  </div>
                </div>
                <div className="preview-item-content">
                  <p className="preview-subject mb-1"><Trans>Profile</Trans></p>
                </div>
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="/admin/update" className="preview-item">
                <div className="preview-thumbnail">
                  <div className="preview-icon bg-dark rounded-circle">
                    <i className="mdi mdi-key text-warning" />
                  </div>
                </div>
                <div className="preview-item-content">
                  <p className="preview-subject mb-1"><Trans>Update Password</Trans></p>
                </div>
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item onClick={this.logout} className="preview-item">
                <div className="preview-thumbnail">
                  <div className="preview-icon bg-dark rounded-circle">
                    <i className="mdi mdi-logout text-danger" />
                  </div>
                </div>
                <div className="preview-item-content">
                  <p className="preview-subject mb-1 text-danger"><Trans>Log Out</Trans></p>
                </div>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </header>
    );
  }
}

export default withRouter(Navbar);
